import styled, { css } from 'styled-components';
import { theme } from '../../../styles/theme';
import { borderedContent } from '../../../styles/shareableStyles';
import { IconWrapper } from '../../Icon';
import SearchInput from '../../Form/SearchInput';

export const headerCellStyles = css`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${theme.colors.tableHeader};
  color: ${theme.colors.secondary800};
  font-size: 12px;
  font-weight: 600;
  user-select: none;
`;

export const HeaderCell = styled.div<{
  $rowIndex: number;
  $columnIndex: number;
}>`
  ${headerCellStyles};
  padding: 8px 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  user-select: none;
`;

export const Cell = styled.div<{
  $rowIndex: number;
  $columnIndex: number;
  $isDisabled?: boolean;
  $backgroundColor?: string;
  $color?: string;
  $isFixedCell?: boolean;
  $isCenterAligned?: boolean;
}>`
  position: relative;

  border-right: 1px solid ${theme.colors.tableHeader};
  border-bottom: 1px solid ${theme.colors.tableHeader};

  font-size: 12px;
  font-weight: 400;
  color: ${({ $color }) => $color || theme.colors.secondary800};

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  padding: 8px 7px;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    color: ${theme.colors.secondary400};
  `};

  ${({ $backgroundColor }) =>
    $backgroundColor &&
    `
    background-color: ${$backgroundColor};
  `};

  ${({ $isFixedCell }) =>
    $isFixedCell &&
    `
    font-weight: 600;
  `};

  ${({ $isCenterAligned }) =>
    $isCenterAligned &&
    `
    text-align: center;
  `};
`;

export const ChartColumnResizeHandle = styled.div`
  position: absolute;
  top: 0;
  height: 32px;

  cursor: col-resize;
  z-index: 2;
  width: 2px;
  right: 0;
  user-select: none;

  &:hover {
    background-color: ${theme.colors.mainBlue};
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SortableContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;
`;

export const BaseCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 8px;
`;

export const ValueCell = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ShowHorizontalBarButton = styled(IconWrapper)`
  ${borderedContent};
`;

export const StyledSearchInput = styled(SearchInput)`
  flex: 0 0 auto;
  width: 175px;
`;
